import type { AllowedCourseItem } from '../types';

// Function to get the next course ID
export function getNextCourseId(currentCourseId: string, allowedCourses: AllowedCourseItem[]): string {
  const currentIndex = allowedCourses.findIndex(
    (course) => course.course_id === currentCourseId,
  );

  // If the course is found and it's not the last one, return the next course
  if (currentIndex !== -1 && currentIndex < allowedCourses.length - 1) {
    return allowedCourses[currentIndex + 1].course_id;
  }

  // If the current course is the last one or not found, return the first course
  return allowedCourses[0]?.course_id;
}

export function getParameterByName(name: string, url = window.location.href): string | null {
  try {
    const newName = name.replace(/[[\]]/g, '$&');
    const regex = new RegExp(`[?&]${newName}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) {
      return null;
    }

    if (!results[2]) {
      return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  } catch {
    return null;
  }
}
